import { render, staticRenderFns } from "./email_list_input.vue?vue&type=template&id=60ed60df&scoped=true&"
import script from "./email_list_input.vue?vue&type=script&lang=js&"
export * from "./email_list_input.vue?vue&type=script&lang=js&"
import style0 from "./email_list_input.vue?vue&type=style&index=0&id=60ed60df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ed60df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60ed60df')) {
      api.createRecord('60ed60df', component.options)
    } else {
      api.reload('60ed60df', component.options)
    }
    module.hot.accept("./email_list_input.vue?vue&type=template&id=60ed60df&scoped=true&", function () {
      api.rerender('60ed60df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/email_list_input.vue"
export default component.exports